$(document).ready(function() {
    $('#wad-popup-modal').modal('show');
});
